import { lazy, Suspense, useEffect, useState } from "react";

/// Components
import Index from "./jsx";
import { connect, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
// action
import { checkAutoLogin } from "./services/AuthService";
import {
  isAuthenticated,
  isAuthenticatedUser,
} from "./store/selectors/AuthSelectors";
/// Style
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as signalR from "@microsoft/signalr";
import { useChatContext } from "./context/ChatContext";
import { handleKeyDownForm } from "./jsx/pages/LIMSpages/CommonFunctions";
import { useConfigContext } from "./context/ConfigContext";
import CustomerLogin from "./jsx/pages/CustomerLogin";
import { HealthCheck, Logout } from "./store/actions/AuthActions";
import { Modal } from "react-bootstrap";

// const SignUp = lazy(() => import('./jsx/pages/Registration'));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./jsx/pages/ResetPassword"));

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();

  const { updateChat } = useChatContext();

  const config = useConfigContext();

  const [showAutoLogoutModal, setShowAutoLogoutModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(10); // Start the timer at 10 seconds

  const checkHealth = () => {
    dispatch(HealthCheck(navigate));
  };

  useEffect(() => {
    // Add event listener when component mounts
    document.addEventListener("keypress", handleKeyDownForm);

    checkHealth();

    // const SIGNAL_R_URL = process.env.REACT_APP_SIGNAL_R_URL;
    // const SIGNAL_R_URL = config?.SIGNAL_R_URL; // use config.json
    let SIGNAL_R_URL;

    const currentHost = window.location.hostname;
    if (
      currentHost === "localhost" ||
      currentHost === "127.0.0.1" ||
      currentHost === "::1" ||
      currentHost.startsWith("192.168.") ||
      currentHost.startsWith("10.") ||
      currentHost.startsWith("172.")
    ) {
      SIGNAL_R_URL = config?.SIGNAL_R_URL_LOCAL_NETWORK; // Local API
    } else {
      SIGNAL_R_URL = config?.SIGNAL_R_URL;
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(SIGNAL_R_URL) // Replace with your actual SignalR endpoint
      .build();

    // Start the connection
    connection
      .start()
      .then(() => {
        console.log("SignalR connection started.");
      })
      .catch((error) => {
        console.error("Error starting SignalR connection:", error);
      });

    // Subscribe to events from the server
    connection.on("GetMessage", (message) => {
      updateChat(message);

      /* Update your React state or perform any necessary action */
      // console.log("GetMessage", message);
    });

    connection.on("ChatDeleteMessage", (message) => {
      updateChat("", message);

      /* Update your React state or perform any necessary action */
      //console.log("ChatDeleteMessage", message);
    });

    connection.on("GetUnReadMessageCount", (messageUnread) => {
      localStorage.setItem("userUnReadMessageCount", messageUnread);

      /* Update your React state or perform any necessary action */
      //  console.log("Signalr Mesg", messageUnread);
    });

    connection.on("GetLoginAction", (res) => {
      const AuthUserString = localStorage.getItem("userDetails");
      const AuthUser = AuthUserString ? JSON.parse(AuthUserString) : null;

      if (AuthUser && res) {
        if (
          AuthUser.ReferenceIDEncrypt == res.ReferenceIDEncrypt &&
          AuthUser.UserType == res.UserType &&
          res.DeviceType == 1
        ) {
          setTimeLeft(10); //reset timer for 2nd time onwards; other wise logout in 0 seconds
          setShowAutoLogoutModal(true);
        }
      }
    });

    if (
      !location?.pathname?.includes("/reset-password") &&
      !location?.pathname?.includes("/forgot-password") &&
      !location?.pathname?.includes("/customer-login")
    ) {
      checkAutoLogin(dispatch, navigate);
    }

    connection.onclose(() => {
      console.log("SignalR connection closed.");
    });

    // Clean up the event listener when component unmounts
    return () => {
      if (connection) {
        connection.stop();
      }
      document.removeEventListener("keypress", handleKeyDownForm);
    };
  }, []);

  // Timer logic
  useEffect(() => {
    let timer;
    if (showAutoLogoutModal && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    // Clean up the timer if modal is closed or timer finishes
    if (timeLeft === 0) {
      clearInterval(timer);
      setShowAutoLogoutModal(false);
      dispatch(Logout(navigate));
    }

    return () => clearInterval(timer); // Cleanup timer on component unmount or effect change
  }, [showAutoLogoutModal, timeLeft]);

  let routeblog = (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* <Route path='/page-register' element={<SignUp />} /> */}
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/reset-password/:PrimaryIdParam"
        element={<ResetPassword />}
      />
      <Route
        path="/reset-password/:PrimaryIdParam/:CompanyIDParam/:CompanyNameParam/:UserTypeParam/:LoginIDParam"
        element={<ResetPassword />}
      />
      <Route
        path="/customer-login/:CompanyIDParam/:CompanyNameParam"
        element={<CustomerLogin />}
      />
      <Route path="/customer-login" element={<CustomerLogin />} />
    </Routes>
  );
  if (props.isAuthenticated) {
    return (
      <>
        <ToastContainer />
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
          <Modal
            className="fade"
            show={showAutoLogoutModal}
            onHide={setShowAutoLogoutModal}
            backdrop="static"
            centered
          >
            <Modal.Body>
              <div className="text-center">
                <div class="swal-icon swal-icon--warning">
                  <span class="swal-icon--warning__body">
                    <span class="swal-icon--warning__dot"></span>
                  </span>
                </div>
                <h1>Logout in {timeLeft} seconds</h1>
                <br></br>
                <p>Login detected on another system with your account.</p>
              </div>
            </Modal.Body>
          </Modal>
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <ToastContainer />
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routeblog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //isAuthenticated: isAuthenticated(state),
    isAuthenticated: isAuthenticatedUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
